<template>
  <rt-section icon="rt-base-device" title="附件">
    <el-upload
      slot="btn"
      ref="upload"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-change="fileChanged"
      :action="fileUploadUrl"
      :headers="config"
      :data="fileData"
      :name="fileName"
      :file-list="fileList"
      :show-file-list="false"
      :auto-upload="true"
      multiple
    >
      <rt-button-group>
        <rt-button icon-name="rt-base-plus_bold"></rt-button>
      </rt-button-group>
    </el-upload>

    <div v-if="fileList.length <= 0" class="empty-file">
      <p>暂时没有附件哦~</p>
    </div>
  </rt-section>
</template>
<script>
export default {
  name: 'RtAttachment',
  props: {
    // 模块名称
    controllerName: {
      type: String,
      default: ''
    },
    ObjectId: {
      type: String,
      default: ''
    },
    // 附件Module
    moduleType: {
      type: String
    }
  },
  data() {
    return {
      fileUploadUrl: 'https://jsonplaceholder.typicode.com/posts/',
      fileName: '',
      config: {
        Authorization: 'Bearer ' + this.$store.state.auth.accessToken
      },
      fileData: {
        ModuleType: this.moduleType,
        FileId: '',
        FileName: this.fileName,
        ObjectId: this.objectId,
        IsOverwrite: '0'
      },
      fileList: []
    };
  },
  methods: {
    addAttachment() {},
    uploadSuccess(response, file, fileList) {
      let success = true;
      this.fileList = fileList;
      console.log(this.fileList);
      fileList.forEach(item => {
        if (item.status !== 'success') {
          success = false;
        }
      });
      if (success) {
        this.$message({
          showClose: true,
          message: '附件上传成功！',
          type: 'success'
        });
      }
    },
    uploadError(err, file) {
      console.log('上传失败');
      // 上传失败
      //   this.$message({
      //     showClose: true,
      //     message: err,
      //     type: "error"
      //   });
    },
    // 文件改变触发
    fileChanged(file, fileList) {
      console.log('文件改变');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAttachment.vue?abc3441e